import Component from 'flarum/Component';
import listItems from 'flarum/helpers/listItems';

/* global m */

export default class FormTitle extends Component {
    view() {
        const {form} = this.props;
        const badges = form.badges().toArray();

        return m('h2', [
            form.title(),
            badges.length ? m('ul.FormulaireDataTable-badges.badges', listItems(badges)) : null,
        ]);
    }
}
